module.exports = __webpack_public_path__ + "static/media/993953.f5064556.png";